import React from "react";
import AutoScroll from "./AutoScroll";
import { useStore } from "@/store/StoreContext";
import { imgSrc } from "@/lib/api";

export default function Celebrities() {
  const { showcase, content } = useStore();
  const CELEBRITIES = showcase.celebrity || [];
  if (!CELEBRITIES.length) return null;
  return (
    <section id="celebrities" data-testid="celebrities" className="relative overflow-hidden bg-[#F6EEDC] py-12 lg:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal mb-9 text-center">
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{content?.celebrities_eyebrow || "Trusted by Seekers Worldwide"}</p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl lg:text-5xl">
            {content?.celebrities_title || "Celebrities &"} <span className="text-gold-gradient italic">{content?.celebrities_accent || "Well-Wishers"}</span>
          </h2>
          <p className="font-display mx-auto mt-4 max-w-xl text-lg italic text-[#6B5B45]">
            {content?.celebrities_subtext || "From spiritual practitioners to professionals and leaders, Rudralife serves a diverse global community."}
          </p>
        </div>
        <AutoScroll testid="celebrities-scroller" speed={0.85} itemWidth={224} pausable={false}>
          {CELEBRITIES.map((c) => (
            <figure
              key={c.name}
              data-testid={`celebrity-card-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group relative overflow-hidden rounded-md border border-[#E0D3B4] bg-white"
            >
              <img
                src={imgSrc(c.image)}
                alt={c.name}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C130B]/85 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 w-full p-4 text-center">
                <p className="font-display text-lg font-semibold text-[#F3E5AB]">{c.name}</p>
                {c.text && <p className="mt-0.5 text-[11px] font-medium uppercase tracking-[0.18em] text-[#F3E5AB]/75">{c.text}</p>}
              </figcaption>
            </figure>
          ))}
        </AutoScroll>
      </div>
    </section>
  );
}
